import React from 'react'
import { Drawer as AntdDrawer } from 'antd'
import styled from 'styled-components'
import Footer from './partials/Footer'

const StyledDrawer = styled(AntdDrawer)`
  .ant-drawer-body {
    padding: ${props => (props.padding ? props.padding : '30px')};
  }
  .ant-drawer-wrapper-body {
    height: ${props => props.height};
    overflow: auto;
  }
  .ant-drawer-header {
    margin: ${props => (props.headermargin ? props.headermargin : '0')};
    padding: ${props =>
      props.headerpadding ? props.headerpadding : '16px 24px'};
  }
  .ant-drawer-header-title {
    flex-direction: ${props =>
      props.closeIconPosition == 'right' ? 'row-reverse' : 'row'};
  }
`

const Drawer = ({
  width = '40%',
  height = '92%',
  title,
  placement,
  closable = false,
  onClose,
  visible,
  content,
  footer,
  footerStyles,
  closeIconPosition = 'right',
  padding,
  destroyOnClose = false,
  maskClosable = true,
  scrollRef,  
  ...rest
}) => {
  return (
    <StyledDrawer
      {...rest}
      width={width}
      title={title}
      placement={placement}
      closable={closable}
      onClose={onClose}
      open={visible}
      key={placement}
      closeIconPosition={closeIconPosition}
      padding={padding}
      height={height}
      destroyOnClose={destroyOnClose}
      maskClosable={maskClosable}
    >
      {/* attach ref to body or wrapper */}
      <div ref={scrollRef}>
        {content}
      </div>

      {footer && <Footer footerStyles={footerStyles}>{footer}</Footer>}
    </StyledDrawer>
  )
}

export default Drawer
